import _ from 'lodash';

import { AssetReplacer } from 'Helpers/replacer/AssetReplacer';
import { GetLocalState } from 'Connectivity/LocalStorage';

export const CoreConfig = {

  get API()                       { return GetLocalState('settings')?.api; },
  get CDN()                       { return GetLocalState('settings')?.paths?.CDN; },
  get ASSETS()                    { return GetLocalState('settings')?.paths?.ASSETS; },

  get BackOfficeName()            { return GetLocalState('platform')?.BackOfficeName; },
  get BackOfficeDomain()          { return GetLocalState('platform')?.BackOfficeDomain; },
  get PlatformNameSlug()          { return GetLocalState('platform')?.PlatformNameSlug; },
  get PlatformEMailContact()      { return GetLocalState('platform')?.PlatformEMailContact; },
  get PlatformEMailHelpDesk()     { return GetLocalState('platform')?.PlatformEMailHelpDesk; },
  get PlatformName()              { return GetLocalState('platform')?.PlatformName; },
  get PlatformCountry()           { return GetLocalState('platform')?.PlatformCountry; },
  get PlatformLink()              { return GetLocalState('platform')?.PlatformLink; },
  get PlatformCopyrightYear()     { return GetLocalState('platform')?.PlatformCopyrightYear; },

  get ClientId()                  { return GetLocalState('login')?.client.id; },
  get ClientDomain()              { return GetLocalState('login')?.client.domain; },
  get ClientName()                { return GetLocalState('login')?.client.name; },
  get ClientSlug()                { return GetLocalState('login')?.client.slug; },
  get ClientSiteName()            { return GetLocalState('login')?.client.siteName; },
  
  get CaptchaKey()                { return GetLocalState('settings')?.CaptchaKey; },
  get CaptchaSecretKey()          { return GetLocalState('settings')?.CaptchaSecretKey; },
  get StaticAllID()               { return GetLocalState('settings')?.StaticAllID; },
  get DefaultDateFormat()         { return GetLocalState('settings')?.date?.defaultFormat; },
  get DefaultDateFormatWithTime() { return GetLocalState('settings')?.date?.defaultFormatWithTime; },

  get Paging()                    { return GetLocalState('settings')?.paging; },
  get PageSizes()                 { return GetLocalState('settings')?.pageSizes; },
  get Paths()                     { return GetLocalState('settings')?.paths; },
  get Roles()                     { return GetLocalState('settings')?.roles; },
  get Queries()                   { return GetLocalState('settings')?.queries; },
  get Defaults()                  { return GetLocalState('settings')?.defaults; },
  get Warnings()                  { return GetLocalState('settings')?.warnings; },
  get Values()                    { return GetLocalState('settings')?.values; },
  get Variables()                 { return GetLocalState('settings')?.variables; },
  get Types()                     { return GetLocalState('settings')?.types; },
  get Socket()                    { return GetLocalState('settings')?.socket; },
  get ExportAsyncThreshold()      { return GetLocalState('settings')?.export?.asyncThreshold ?? 0; },
  get ExportPdfPageLimit()        { return GetLocalState('settings')?.export?.pdfPageLimit ?? 1000; },

  get Languages()                 { return GetLocalState('languages'); },
  get Currencies()                { return GetLocalState('currencies'); },
  get Countries()                 { return GetLocalState('countries'); },
  get Modals()                    { return GetLocalState('modals'); },
  get Menus()                     { return GetLocalState('menus'); }

};

export const Asset = (name:string, addClientToPath = false) => {

  const path = _.get(GetLocalState('assets'), name);

  return AssetReplacer(path, addClientToPath);

}
